import React, { useEffect } from 'react';
import { useBootstrap } from '../context/BootstrapContext.jsx';
import { usePageStyles, useLucideIcons } from '../hooks/usePageAssets.js';
import { resolveStaticUrl } from '../utils/staticAssets.js';

const LandingPage = () => {
  const bootstrap = useBootstrap();
  usePageStyles([resolveStaticUrl('css/landing.css')]);
  useLucideIcons([]);

  useEffect(() => {
    document.body.classList.add('landing-body');
    return () => document.body.classList.remove('landing-body');
  }, []);

  useEffect(() => {
    const featureCards = document.querySelectorAll('.feature-card');
    const handleEnter = function handleEnter() {
      this.style.transform = 'translateY(-8px)';
      const icon = this.querySelector('[data-lucide]');
      if (icon) {
        icon.style.transform = 'scale(1.1) rotate(5deg)';
      }
    };
    const handleLeave = function handleLeave() {
      this.style.transform = 'translateY(0)';
      const icon = this.querySelector('[data-lucide]');
      if (icon) {
        icon.style.transform = 'scale(1) rotate(0deg)';
      }
    };
    featureCards.forEach((card) => {
      card.addEventListener('mouseenter', handleEnter);
      card.addEventListener('mouseleave', handleLeave);
    });
    return () => {
      featureCards.forEach((card) => {
        card.removeEventListener('mouseenter', handleEnter);
        card.removeEventListener('mouseleave', handleLeave);
      });
    };
  }, []);

  return (
    <div id="landing-page" className="landing-page">
      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <img src={resolveStaticUrl('images/logo.png')} alt="Tim Hortons" className="logo" />
            <span className="logo-title">Hat Trick</span>
          </div>
        </div>
      </header>

      <main className="main">
        <section className="hero">
          <div className="hero-container">
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">
                  Optimiza la operación de tu restaurante con nuestro modelo de producción inteligente
                </h1>
                <p className="hero-subtitle">
                  Transforma la gestión de tu restaurante Tim Hortons con tecnología avanzada que predice demanda,
                  optimiza recursos y garantiza la excelencia operativa.
                </p>
              </div>

              <div className="login-section">
                <a href={bootstrap?.routes?.login || '/login'} className="login-button">
                  <i className="fas fa-envelope" />
                  <span>Iniciar sesión con tu correo @timhortonsmx.com</span>
                </a>
                <p className="login-note">Acceso exclusivo para personal autorizado</p>
              </div>
            </div>
          </div>
        </section>

        <section className="value-section">
          <div className="value-container">
            <div className="section-header">
              <h2>Potencia tu Restaurante con IA</h2>
              <p>Optimización inteligente que reduce costos y maximiza la eficiencia operativa</p>
            </div>

            <div className="features-grid">
              {[
                { icon: 'dollar-sign', title: 'Reduce Costos de Desperdicio', text: 'Sabe exactamente qué producir y cuándo, eliminando hasta 30% del desperdicio de comida que afecta tus márgenes de ganancia.' },
                { icon: 'clock', title: 'Ahorra Tiempo de tu Equipo', text: 'No más adivinanzas en la cocina. El sistema te dice cuándo preparar cada producto para tener siempre lo que tus clientes necesitan.' },
                { icon: 'smile', title: 'Clientes Más Satisfechos', text: 'Evita quedarte sin productos populares y mantén todo fresco. Menos quejas, más ventas y clientes que regresan.' },
                { icon: 'trending-up', title: 'Incrementa tus Ventas', text: 'Predice la demanda con precisión y asegúrate de tener suficiente producto cuando más lo necesites. No pierdas ni una venta.' },
                { icon: 'shield-check', title: 'Fácil de Usar y Seguro', text: 'Interface simple que tu equipo aprenderá rápido. Datos protegidos y acceso solo para personal autorizado de Tim Hortons.' },
                { icon: 'bar-chart-3', title: 'Resultados que Puedes Medir', text: 'Ve mejoras reales desde el primer mes: menos desperdicio, más ventas y un restaurante que funciona como un reloj.' }
              ].map((feature) => (
                <div className="feature-card" key={feature.title}>
                  <div className="feature-icon">
                    <i data-lucide={feature.icon} />
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-container">
          <p className="footer-text">&copy; 2025 Tim Hortons MX. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
